module.exports = __webpack_public_path__ + "static/img/box-open.2fa0c250.webp";